import React from "react";
import { observer } from "mobx-react-lite";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import RefundDetailView from "../refundDetailView";
import DistributorRefundDetailViewModel from "../../../../viewModels/finance/refundApprovals/distributorRefunds/distributorRefundDetailViewModel";
import DistributorRefundChargesSection from "./distributorRefundChargesSection";
import DistributorRefundOrderSection from "./distributorRefundOrderSection";

const DistributorRefundDetailView: ViewComponent<DistributorRefundDetailViewModel> = observer(({ vm }) => {
  return (
    <RefundDetailView vm={vm}>
      <div className="mb-4">
        <DistributorRefundOrderSection vm={vm} />
      </div>
      <DistributorRefundChargesSection vm={vm} />
    </RefundDetailView>
  );
});

registerView(DistributorRefundDetailView, DistributorRefundDetailViewModel);
